import * as T from "./types";
import moment from "moment";

const strategyDefault: T.StrategySetup[] = [
  {
    indicator1: [],
    param1: 0,
    compare: ">=",
    indicator2: [],
    param2: 0,
    and: true
  }
];

export const resultDefault: T.BacktestResult = {
  portfolioHistoricalValues: [],
  portfolioFinalValue: 0.0,
  portfolioStatistics: {
    riskReturn: {
      annualReturn: 0.0,
      calmarRatio: 0.0,
      stability: 0.0,
      omegaRatio: 0.0,
      sortinoRatio: 0.0,
      tailRatio: 0.0,
      dailyValueAtRisk: 0.0,
      totalReturn: 0.0,
      cagr: 0.0,
      sharpeRatio: 0.0,
      annualVolatility: 0.0,
      SQN: 0.0,
      rSquared: 0.0,
      maxDailyDrawdown: 0.0,
      maxDrawdownDuration: 0.0
    },
    trades: {
      winningTradePct: 0.0,
      avgTrade: 0.0,
      avgWin: 0.0,
      avgLoss: 0.0,
      bestTrade: 0.0,
      worstTrade: 0.0,
      avgDaysInTrade: 0.0,
      totalTrades: 0
    },
    time: {
      winningMonthsPct: 0.0,
      avgWinningMonthPct: 0.0,
      avgLosingMonthPct: 0.0,
      bestMonthPct: 0.0,
      worstMonthPct: 0.0,
      winningYearsPct: 0.0,
      bestYearPct: 0.0,
      worstYearPct: 0.0
    }
  },
  portfolioReturnMatrix: [],
  portfolioCashValue: {
    datetime: [],
    datasets: []
  },
  portfolioCummulativeReturn: [],
  portfolioRollingVolatility: [],
  portfolioDrawdownTable: [],
  portfolioRollingSharpe: [],
  portfolioRoundTripsSummary: [],
  portfolioRoundTripsProfitLosses: [],
  portfolioRoundTripsDuration: [],
  portfolioRoundTripsReturnsBySymbols: [],
  transactionsRecords: [],
  ohlcWithIndicators: [],
  tradeLog: []
};

export const defaultState: T.Store = {
  loading: {
    backtest: "SUCCESS",
    meta: "SUCCESS",
    ticker: "SUCCESS"
  },
  meta: {
    purchaseType: [],
    regions: [],
    tickers: [],
    indices: [],
    strategyOptions: [],
    compareOptions: [],
    modelOptions: []
  },
  setup: {
    ticker: [],
    stock_peer: [],
    index_peer: [],
    region: "Singapore",
    strategy: {
      buy: strategyDefault,
      sell: strategyDefault
    },
    modelSetup: [],
    period: {
      start: moment()
        .add(-1, "day")
        .add(-24, "month")
        .format("YYYY-MM-DD"),
      end: moment()
        .add(-1, "day")
        .format("YYYY-MM-DD")
    },
    cash: 10000,
    purchase: {
      size: 30,
      type: "portfolio_weights"
    },
    commission: {
      min: 25,
      pct: 0.28
    }
  },
  result: {
    initialCash: 0,
    groupResult: {
      strategy: resultDefault,
      longTerm: resultDefault
    },
    singleResult: [],
    featureImportance: []
  }
};
